<!--

  Implementation

  -in template:
    <dual-prevew-list :hideList1="onlymac || PreviewMachine != null"
                      :hideList2="onlycus || PreviewCustomer != null"
                      :hidePreview1="!PreviewCustomer "
                      :hidePreview2="!PreviewMachine">

      <template v-slot:list1>
        <customer-list :searchStartCharLimit="3"></customer-list>
      </template>

      <template v-slot:list2>
        <machine-list :searchStartCharLimit="3"></machine-list>
      </template>

      <template v-slot:preview1>
        <preview-customer :id="PreviewCustomer.Id"></preview-customer>
      </template>

      <template v-slot:preview2>
        <preview-machine-section :id="PreviewMachine.Id"
                                 :customerId="Customer && Customer.Id ? Customer.Id : false"></preview-machine-section>
      </template>

    </dual-prevew-list>

  -import:
    import DualPrevewList from "@/views/layouts/DualPrevewList.vue";
-->


<template>
  <v-container class="pa-0"
               fluid>
    <v-row no-gutters>

      <v-col v-if="!hideList1"
             cols="12"
             :sm="list1width"
             class="pane listpane">
        <slot name="list1">
          list 1
        </slot>
      </v-col>
      <v-col v-if="!hideList2"
             cols="12"
             :sm="list2width"
             class="pane listpane">
        <slot name="list2">
          list 2
        </slot>
      </v-col>
      <v-col v-if="showPreviewPane1"
             cols="12"
             sm="6"
             class="pane previewpane">
        <slot name="preview1">
          preview 1
        </slot>
      </v-col>
      <v-col v-if="showPreviewPane2"
             cols="12"
             sm="6"
             class="pane previewpane">
        <slot name="preview2">
          preview 2
        </slot>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  name: "PreviewableListLayout",
  props: ["hideList1", "hideList2", "hidePreview1", "hidePreview2"],
  components: {},

  data() {
    return {};
  },

  mounted() {},

  methods: {},

  computed: {
    showPreviewPane1() {
      return !this.hideList1 && !this.hidePreview1;
    },

    showPreviewPane2() {
      return !this.hideList2 && !this.hidePreview2;
    },

    list1width() {
      if (this.hideList2 && !this.showPreviewPane1) {
        return 12;
      } else {
        return this.isPhoneBool ? 12 : 6;
      }
    },

    list2width() {
      if (this.hideList1 && !this.showPreviewPane2) {
        return 12;
      } else {
        return this.isPhoneBool ? 12 : 6;
      }
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
.pane {
  height: 100%;
  overflow-y: auto !important;
}
@media only screen and (max-width: 600px) {
  .listpane {
    height: auto !important;
  }
  .previewpane {
    height: 0 !important;
  }
}
</style>